//Toolkit
import {
  configureStore,
  Reducer,
  combineReducers,
  Slice,
} from "@reduxjs/toolkit";

//Slices
import {
  generalDetailsSlice,
  baseApiDetailsSlice,
  RegisterClientApiDetailsSlice,
  RegisterTechTeamApiDetailsSlice,
  SignupLoginApiDetailsSlice,
  ValidateTokenApiDetailsSlice,
  GetUserDetailsApiDetailsSlice,
  UpdateApplicationApiDetailsSlice,
  AllApplicationsApiDetailsSlice,
  CreateApplicationApiDetailsSlice,
  GetApplicationDetailsApiDetailsSlice,
  CountDetailsApiDetailsSlice,
  GraphDetailsApiDetailsSlice,
  AddUserApiDetailsSlice,
  GetTeamDetailsApiDetailsSlice,
  RemoveUserApiDetailsSlice,
  UpdateOrganisationApiDetailsSlice,
} from "Slices";

interface ISimpleMap {
  [field: string]: Reducer;
}

const reducerMap: ISimpleMap = {
  [generalDetailsSlice.name]: generalDetailsSlice.reducer,
  [baseApiDetailsSlice.name]: baseApiDetailsSlice.reducer,
  [RegisterClientApiDetailsSlice.name]: RegisterClientApiDetailsSlice.reducer,
  [RegisterTechTeamApiDetailsSlice.name]:
    RegisterTechTeamApiDetailsSlice.reducer,
  [SignupLoginApiDetailsSlice.name]: SignupLoginApiDetailsSlice.reducer,
  [ValidateTokenApiDetailsSlice.name]: ValidateTokenApiDetailsSlice.reducer,
  [GetUserDetailsApiDetailsSlice.name]: GetUserDetailsApiDetailsSlice.reducer,
  [UpdateApplicationApiDetailsSlice.name]:
    UpdateApplicationApiDetailsSlice.reducer,
  [AllApplicationsApiDetailsSlice.name]: AllApplicationsApiDetailsSlice.reducer,
  [CreateApplicationApiDetailsSlice.name]:
    CreateApplicationApiDetailsSlice.reducer,
  [GetApplicationDetailsApiDetailsSlice.name]:
    GetApplicationDetailsApiDetailsSlice.reducer,
  [CountDetailsApiDetailsSlice.name]: CountDetailsApiDetailsSlice.reducer,
  [GraphDetailsApiDetailsSlice.name]: GraphDetailsApiDetailsSlice.reducer,
  [AddUserApiDetailsSlice.name]: AddUserApiDetailsSlice.reducer,
  [GetTeamDetailsApiDetailsSlice.name]: GetTeamDetailsApiDetailsSlice.reducer,
  [RemoveUserApiDetailsSlice.name]: RemoveUserApiDetailsSlice.reducer,
  [UpdateOrganisationApiDetailsSlice.name]:
    UpdateOrganisationApiDetailsSlice.reducer,
};

const store = configureStore({
  reducer: combineReducers(reducerMap),
});

export const registerSlice = (slice: Slice): void => {
  reducerMap[slice.name] = slice.reducer;
  store.replaceReducer(combineReducers(reducerMap));
};

export default store;
